import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2F2FC9A9-FAC3-4736-B8EC-B7DF9548586C
 * name music-note-half
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-half.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNoteHalfIcon = createSvgIcon(<><path d="M16 3H14V13.56A3.96 3.96 0 0 0 12 13A4 4 0 1 0 16 17V3M12 19A2 2 0 1 1 14 17A2 2 0 0 1 12 19Z" /></>, 'MusicNoteHalfIcon');
export default MusicNoteHalfIcon